import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavItemComponent } from '../nav-item.component';
import { Router } from '@angular/router';
import { ProductsNavItemViewModel } from './products-nav-item-view-model';

@Component({
  selector: 'app-products-nav-item',
  templateUrl: './products-nav-item.component.html',
  styleUrls: ['./products-nav-item.component.scss', '../nav-item.component.scss'],
  providers: [ProductsNavItemViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductsNavItemComponent extends NavItemComponent {
  constructor(
    public override viewModel: ProductsNavItemViewModel,
    router: Router
  ) {
    super(viewModel, router);
  }
}
